let dataelements = [
    {
        id:1,
        year: 2024,
        school: "SASTRA University",
        course: "B.Tech Computer Science and Engineering",
        location: "Thanjavur",
        score:"CGPA - 8.42",
    },
    {
        id:2,
        year: 2020,
        school: "SSRVM Bangalore East",
        course: "Higher Secondary - 12th Grade",
        location: "Bangalore",
        score: "93%",
    },
    {
        id:3,
        year: 2018,
        school: "SSRVM Bangalore East",
        course: "Secondary - 10th Grade",
        location: "Thanjavur",
        score:"94%",
    },
]

export default dataelements;
